import {useMemo} from 'react';
import {createTheme, ThemeProvider} from '@material-ui/core/styles';
import {CssBaseline} from '@material-ui/core';
import useLocale from '@super-template/core/src/locale/useLocale';
import getMaterialUI from '@super-template/core/src/locale/getMaterialUI';
import './main.css';
import {Button, Dialog, FormControl, MuiTablePagination, MuiTooltip, MuiTypography} from './overrides';
import {customConfig} from "./config";

export default function Theme({locale, children}) {
  const [localeSetting] = useLocale();
  locale = locale ?? localeSetting;

  let theme = customConfig(useMemo(() => createTheme({
      typography: {
        fontFamily: ['Open Sans', 'sans-serif'].join(','),
        bold: ['Open Sans SemiBold', 'sans-serif'].join(','),
        fontWeightBold: 400
      },
      palette: {
        type: 'light',
        primary: {
          main: '#003647',
          light: '#eeeeee',
        },
        error: {
          main: '#E91B0C'
        }
      }
    },
    getMaterialUI(locale)),
    [locale]
  ));

  theme = {
    ...theme,
    overrides: {
      MuiTooltip: MuiTooltip(theme),
      MuiTypography,
      MuiTablePagination: MuiTablePagination(theme),
      ...Button(theme),
      ...FormControl(theme),
      ...Dialog
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      {children}
    </ThemeProvider>
  );
}
